/* Copyright (c) The Colour Flooring Company. All rights reserved. */

setInterval(function(){
  var url = $('.ajax-cart__product-title a').attr('href');
  //console.log('url=>'+url);
  if (url != undefined) {
    url = url.split("?");
    if(url[0] == '/products/melaza-corka-tile'){
        $( ".gallery-cell" ).each(function() {
         var newId = $(this).attr('id');
        if(newId == 'amorim-eco21db-15sqm-roll'){
            console.log('#'+newId);
            $('#'+newId).remove();
        }     
        });
    }
  }
}, 100);

var noticeInterval;
var intervalTime = 1000;
// Define module
shopify = (function ($, window) {
  // Public methods
  return {
    // Functions for cart.liquid
    cart: {
      // Validate terms checkbox
      terms: function (el) {
        // define target elements
        var el = $('.cart .agree'),
            input = el.find('input'),
            submit = $('.cart form .checkout');
        // check if element is in dom
        if (el.length) {
          submit.on('click', function() {
            if (!input.is(':checked')) {
              alert('Oops, you must agree to our Terms & Conditions to checkout.');
              return false;
            }
          });
        }
      },
      addProduct: function(data){
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          async: false,
          cache: false,
          data: {items:data},
          dataType: "json",
          success: function (data) {
            //Shopify.theme.jsAjaxCart.showDrawer();
        	Shopify.theme.jsAjaxCart.updateView();
          },
          error: shopify.collection.samples.failed
        });
        
        
      },
      sampleCostCheck: function(){
    	 $.ajax({
          type: 'GET',
          dataType: 'jsonp',
          url: '/cart.json',
          success: function(cart){
            if(cart.items.length != 0){

              // remove cost of 6 products
              var sample_qty = 0;
              var isCostProdAdded = 0;
              var isCostProdID = 0;
              for(var i = 0; i < cart.items.length; i++){
                var qty=cart.items[i]['quantity'];
                var item_id=cart.items[i]['product_id'];
                var item_title=cart.items[i]['title'];
                var item_price=cart.items[i]['price'];
                var item_variant_id=cart.items[i]['key'];
                if(item_title.indexOf("Cost for up to") == -1){
                  if((item_title.indexOf("Sample") != -1 || item_title.indexOf("sample") != -1) && item_price <= 0 ){
                    sample_qty++;
                  }
                }else{
                  isCostProdAdded = 1; 
                  isCostProdID = item_variant_id;
                }
              }
              if(isCostProdAdded && sample_qty < 4){

                shopify.cart.removeSample(isCostProdID);
                
              }
            }
          }
        });
      },
      removeSample: function(id){
		 $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {'id': id,'quantity': 0},
          dataType: 'json',
          success: function success(cart) {
            Shopify.theme.jsAjaxCart.updateView();
          },
          error: function error(XMLHttpRequest, textStatus) {
            
          }
        });
      
      },
      setProductProperties:function(id,qty){
        if(typeof Cookies.get('campaign_name') !== "undefined" && typeof Cookies.get('campaign_parameter') !== "undefined" ){
          var dataObj = {
            quantity: qty,
            id: id,
            properties: {
              'campaign_name': Cookies.get('campaign_name'),
              'campaign_parameter': Cookies.get('campaign_parameter')
            }
          };

        }else{
          var dataObj = {
            quantity: qty,
            id: id
          };                              

        }
        return dataObj;
      },
      updateButton:function(id,button,isCollection){
      	$.ajax({
          type: "GET",
          url: "/cart.js",
          async: false,
          cache: false,
          dataType: "json",
          success: function (cart) {
            for(var i = 0; i < cart.items.length; i++){
              if( cart.items[i].variant_id == id ){
                if(isCollection){
                	button.prev('img').prev('img').removeClass('active');
                	button.prev('img').addClass('active');
              		button.addClass('added active').attr('data-key',cart.items[i].key).find('span').text('REMOVE FROM CART');
                }else{
                	button.addClass('added').attr('data-key',cart.items[i].key);
                  button.val("REMOVE FROM CART");
                }
                
              }
            }
          }
        });
      },
      resetDefaultButton:function(itemKey){
        if($('.button--add-to-cart.added[data-key="'+itemKey+'"]').length > 0){
          intervalTime=1000;
          shopify.helpers.notice('<h5><b>Sample removed from cart</b></h5>');
        	$('.button--add-to-cart.added[data-key="'+itemKey+'"]').find('span').text("ADD TO CART");
          	//$('.button--add-to-cart.added[data-key="'+itemKey+'"]').prev('img').removeClass('active');
          	//$('.button--add-to-cart.added[data-key="'+itemKey+'"]').prev('img').prev('img').addClass('active');
          	$('.button--add-to-cart.added[data-key="'+itemKey+'"]').removeClass('added').removeAttr('data-key');
        }
        
        if($('.ajax-cart__forms[data-key="'+itemKey+'"]').length > 0){
          intervalTime=1000;
          shopify.helpers.notice('<h5><b>Sample removed from cart</b></h5>');
        	$('.ajax-cart__forms[data-key="'+itemKey+'"]').val("ADD TO CART").removeClass('added').removeAttr('data-key');
        }
        
        /*if($('.ajax-cart__formss[data-key="'+itemKey+'"]').length > 0){
        	$('.ajax-cart__formss[data-key="'+itemKey+'"]').val("ADD TO CART").removeClass('added').removeAttr('data-key');
        }*/
      }
    },
    // Functions for collection.liquid
    collection: {
      // filtering collection items
      filter: function() {
        // define target elements
        var el = $('.collection .filter'),
            buttons = el.find('h6');
        // check if element is in dom
        if ($(el).length) {
          // remove border from last colour element
          el.find('.colours:last').addClass('end');
          // show and hide options for touch device
          if (Modernizr.touch) {
            // show and hide options
            buttons.on('click', function() {
              if ($(this).parent().hasClass('active')) {
                el.removeClass('active');
              } else {
                el.removeClass('active');
                $(this).parent().addClass('active');
              }
              return false;
            });
          }
          // show and hide menus on non-touch devices
          else {
            // show and hide menus
            el.on('mouseover', function() {
              $(this).addClass('active');
            });
            el.on('mouseout', function() {
              $(this).removeClass('active');
            });
          }
        }
      },
      // Manipulating collection items
      item: function() {
        // define target elements
        var el = $('.item .image');
        // check if element is in dom
        if (el.length) {
          // loop through all matching elements
          el.each(function () {
            // show and hide images
            var image = $(this),
                attr = image.attr('style'),
                link = image.parent();
            if (image.find('img').length > 1 || (typeof attr !== 'undefined' && attr !== false)) {
              // show and hide images for touch device
              if (Modernizr.touch) {
                // toggle only on samples collection
                if (link.is('form')) {
                  // show and hide images
                  link.unbind('click');
                  link.on('click', function() {
                    if(!link.find('p').hasClass('added')){
                    var clicked = $(this);
                    clicked.addClass('clicked');
                    if (clicked.find('img:last').hasClass('active')) {
                      clicked.find('img, p').toggleClass('active').promise().done(function() {
                        if (clicked.is('a')) {
                          window.location = clicked.attr('href');
                        }
                      });
                    } else {
                      clicked.find('img, p').toggleClass('active').promise().done(function() {
                        el.each(function() {
                          if ($(this).parent().hasClass('clicked')) {
                            $(this).parent().removeClass('clicked');
                          } else {
                            $(this).find('img, p').removeClass('active');
                            $(this).find('img:first').addClass('active');
                          }
                        });
                      });
                    }
                  	}
                    return false;
                  });
                }
              }
              // show and hide images on non-touch devices
              else {
                // show and hide image
                image.unbind('mouseover mouseout');
                image.on('mouseover mouseout', function() {
                  if(!image.find('p').hasClass('added')){
                    $(this).find('img, p').toggleClass('active');
                  }
                  
                });
                link.on('click', function() {
                  //$(this).find('img, p').toggleClass('active');
                  if(!link.find('p').hasClass('added')){
                    $(this).find('img, p').toggleClass('active');
                  }
                });
              }
            }
          });
        }
        
        let grid = $(".collection__main .product__grid-item");
        if(grid.length >0){
          grid.each(function () {
          	var element = $(this);
            var hoverElement = element.find('a');
            if (Modernizr.touch) {
            	 hoverElement.unbind('click');
                hoverElement.on("click",function(){
					hoverElement.find('img').toggleClass('swap--visible');
                });
            }else{
            	hoverElement.unbind('mouseover mouseout');
                hoverElement.on('mouseover mouseout', function() {
                  hoverElement.find('img').toggleClass('swap--visible');
                });
            }
            
          });
        }
        
      },
      samples: {
        
        add:function(){
          
          $(document).on("click","div.item form p.button--add-to-cart",function(event){
          	
          	event.preventDefault();
            
            if($(this).hasClass('added')){
              	var itemKey = $(this).data('key');
              	$('a.ajax-cart__delete[data-cart-item-key="'+itemKey+'"]').trigger('click');
            	return;
            }
            
          	var form = $(this).parents("form");
            var id = form.find('[name="id"]').val();
            var qty = form.find('[name="quantity"]').val();
            var buttonObject = $(this);
            $.ajax({
              type: "GET",
              url: "/cart.js",
              async: false,
              cache: false,
              dataType: "json",
              success: function (cart) {
                shopify.collection.samples.processSample(cart,id,qty,buttonObject,true);
              },
              error: shopify.collection.samples.failed
            });      
          
          });
        },
        processSample:function(cart,id,qty,button,isCollection){
        	var sampleCount = 0;
          var sampleId;
          var alreadyCharged = false;
          var inCart = false;
          var count = 0;
          for(var i = 0; i < cart.items.length; i++){
            if(cart.items[i].variant_title == 'Sample' && cart.items[i].price == 0 && cart.items[i].handle != 'cost-for-up-to-6-samples'){
              var sampleCount = sampleCount + 1;
              var sampleId = cart.items[i].variant_id;
            }

            if( cart.items[i].variant_id == id ){
              var inCart = true;
            }

            if( cart.items[i].variant_id == '3217500356' ){
              var alreadyCharged = true;
            }

          }
          if( inCart === false ){
            if( sampleCount === 3 && alreadyCharged == false){
              var data = [];
              data.push(shopify.cart.setProductProperties(id,qty));
              data.push(shopify.cart.setProductProperties(3217500356,1));
              shopify.cart.addProduct(data);
              intervalTime = 3000;
              shopify.helpers.notice('<h5><b>YOU HAVE ADDED<br />MORE THAN 3 FREE SAMPLES.<br />YOU WILL NOW BE CHARGED <span class="money">£' + shopify.helpers.money(399 /100) + '</span><br />FOR UP TO 6 SAMPLES.</b></h5>', "small");
              shopify.cart.updateButton(id,button,isCollection);
              
            }else if( sampleCount === 3 ) {
              var data = [];
              data.push(shopify.cart.setProductProperties(id,qty));
              shopify.cart.addProduct(data);
              intervalTime = 3000;
              shopify.helpers.notice('<h5><b>YOU HAVE ADDED<br />MORE THAN 3 FREE SAMPLES.<br />YOU WILL NOW BE CHARGED <span class="money">£' + shopify.helpers.money(399 /100) + ' </span><br />FOR UP TO 6 SAMPLES.</b></h5>', "small");
               shopify.cart.updateButton(id,button,isCollection);
            }else if( sampleCount === 6 ) {
              /*var data = [];
              data.push(shopify.cart.setProductProperties(id,qty));
              shopify.cart.addProduct(data);*/
              intervalTime = 3000;
              shopify.helpers.notice('<h5><b>6 SAMPLES ORDERED. <a href="/cart">GO TO CHECKOUT</a></b></h5>');
              if(isCollection){
              	$('div.item form').addClass('inCart');
              }

            }else if( sampleCount > 6 ) {
              intervalTime = 3000;
              shopify.helpers.notice('<h5><b>6 SAMPLES ORDERED. <a href="/cart">GO TO CHECKOUT</a></b></h5>');
            }else{
              
              var data = [];
              data.push(shopify.cart.setProductProperties(id,qty));
              shopify.cart.addProduct(data);
              intervalTime = 1000;
              shopify.helpers.notice('<h5><b>Sample added to cart</b></h5>');
              shopify.cart.updateButton(id,button,isCollection);
            }

          }else{
            intervalTime = 1000;
            shopify.helpers.notice('<h5><b>THIS SAMPLE IS ALREADY IN YOUR CART</b></h5>');
          }
        },
        failed: function (jqXHR, textStatus, errorThrown) {
          // Get, show, and log error from response
          var error = $.parseJSON(jqXHR.responseText);
          intervalTime = 1000;
          intervalTime = 3000;("<h4 class='test'>" + error.description + "</h4>", "small");
          shopify.helpers.log("OKOK"+error.description);
        },
        
      }
    },
    product:{
      samples:{
        add:function(){
          $(document).on("click",".ajax-cart__forms",function(event){
          	event.preventDefault();
            event.stopPropagation();
            
            
            if($(this).hasClass('added')){
              	var itemKey = $(this).data('key');
              	$('a.ajax-cart__delete[data-cart-item-key="'+itemKey+'"]').trigger('click');
            	return;
            }
            
            var $addToCartForm = $(this).closest('form');
            var id = $addToCartForm.find('input[name="id"]').val();
            var qty = $addToCartForm.find('input[name="quantity"]').val();
            
          	var buttonObject = $(this);
            $.ajax({
              type: "GET",
              url: "/cart.js",
              async: false,
              cache: false,
              dataType: "json",
              success: function (cart) {
                shopify.collection.samples.processSample(cart,id,qty,buttonObject,false);
              },
              error: shopify.collection.samples.failed
            });  
            
            return false;
          });
          
          /*$(document).on("click",".ajax-cart__formss",function(event){
          	event.preventDefault();
            event.stopPropagation();
            
            
            if($(this).hasClass('added')){
              	var itemKey = $(this).data('key');
              	$('a.ajax-cart__delete[data-cart-item-key="'+itemKey+'"]').trigger('click');
            	return;
            }
            
            var $addToCartForm = $(this).closest('form');
            var id = $addToCartForm.find('input[name="id"]').val();
            var qty = $addToCartForm.find('input[name="quantity"]').val();
            
          	var buttonObject = $(this);
            $.ajax({
              type: "GET",
              url: "/cart.js",
              async: false,
              cache: false,
              dataType: "json",
              success: function (cart) {
                shopify.collection.samples.processSample(cart,id,qty,buttonObject,false);
              },
              error: shopify.collection.samples.failed
            });  
            
            return false;
          });*/
        }
      }
    },
                     
    // Helpers for other functions
    helpers: {
      // Cross browser console.log
      log: function (x) {
        if (window.console && window.console.log) {
          console.log(x);
        }
      },
      // Checks if string is a float (from previous theme)
      isfloat: function (s) {
        var n = shopify.helpers.trims(s);
        return n.length > 0 && !(/[^0-9.]/).test(n) && (/\.\d/).test(n);
      },
      // Checks if string is an integer (from previous theme)
      isinteger: function (s) {
        return (s.toString().search(/^-?[0-9]+$/) == 0);
      },
      // Currency format
      money: function (n) {
        return n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      },
      // Rounds a number (from previous theme)
      rounds: function (n, d) {
        var result = Math.round(n * Math.pow(10, d)) / Math.pow(10, d);
        return result;
      },
      // Custom notice box
      notice: function (message, width, img) {
        // Insert message to DOM
        if (img === undefined) {
          $("body").append('<div class="notice ' + width + '"><div class="overlay"></div><div class="box"><h6>CLOSE</h6><div class="details">' + message + '</div></div></div>');
        } else {
          $("body").append('<div class="notice ' + width + '"><div class="overlay"></div><div class="box"><h6>CLOSE</h6><div class="cols clearfix"><div class="img"><img src="' + img + '" alt=""></div><div class="details">' + message + '</div></div></div></div>');
        }
        clearInterval(noticeInterval);
        noticeInterval = setTimeout(function(){
          $("div.notice").animate({opacity: 0}, 200, function () {
            $("div.notice").remove();
          });
        },intervalTime);
        // Set vertical position based on notice height
        var top = "-" + (parseFloat($("div.notice div.box").height()) / 2 + 20) + "px";
        $("div.notice div.box").css("margin-top", top);
        // Show message and fade out on click
        $("div.notice").animate({opacity: 1.0}, 200, function () {
          $("div.overlay, div.box h6:first").click(function () {
            $("div.notice").animate({opacity: 0}, 200, function () {
              $("div.notice").remove();
            });
          });
        });
      },
      // Custom alert box
      popup: function (message) {
        // Set popup top position based on preheader height
        var top = parseFloat($("div.preheader").height()) + 11;
        // Insert message to DOM
        $("div.preheader div.container").append('<div class="popup" style="top: ' + top + 'px;"><div><div></div></div><p>' + message + '</p></div>');
        // Show message then automatically fade out
        $("div.popup").fadeIn(200, function () {
          window.setTimeout(function () {
            $("div.popup").fadeOut(200, function () {
              $("div.popup").remove();
            });
          }, 3000);
        });
      },
      // Trims a string (from previous theme)
      trims: function (s) {
        return s.replace(/^\s+|\s+$/g, "");
      }
    }
   };
})(jQuery, window);




// Do stuff when the DOM is ready
jQuery(function ($) {
  shopify.cart.terms();
  shopify.collection.filter();
  shopify.collection.item();
  shopify.collection.samples.add();
  shopify.product.samples.add();
});

let isMobile = false;

$(document).ready(function() {
	$(".cork_popup").fancybox();
    $(".sus_link").fancybox();
    $('.main_out_of_stock').click(function(){
      //alert("okok");
      var title=$(this).data('titel');
      intervalTime=1000;
      shopify.helpers.notice("<h4 class='test'>The product '"+title+"' is already sold out.</h4>", "small");
      return false;
    });

  /*$('.vari_out_of_stock').click(function(){
    //alert("okok");
    var title=$(this).data('titel');
    shopify.helpers.notice("<h4 class='test'>The product '"+title+"' is  sold out,delivery will be delayed.</h4>", "small");
    //return false;
  });*/
  
  
      $('.popup-modal').magnificPopup({
        type: 'inline',
        preloader: false,
        focus: '#username'
      });
      $(document).on('click', '.popup-modal-dismiss', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
      });
  
  updateFilterMenu();
  $(document).on("click",".flt-title",function(){
    
    if(!isMobile){
      return false;
    }
    
    if($(this).hasClass('open_filter')){
      $(this).removeClass('open_filter');
      $(this).next().hide();
    }else{
      $(this).next().show();
      $(this).addClass('open_filter');
    }
  });
  
  
  $(window).on("resize",function(){
  	setTimeout(updateFilterMenu,300);
  });
  
  $(document).on("click",".filter.material li a.active_filter",function(){
  	window.location = $(this).data('collection');
    return false;
  });
});

function updateFilterMenu(){
	
  var window_width = $(window).width();
    
    if(window_width <= 767)
    {
      isMobile = true;
      $(".flt-title").addClass("open_filter");
      $(".flt-title").next().show();
      
    }else{
      isMobile = false;
    	$(".flt-title").removeClass("open_filter");
      	$(".flt-title").next().show();
    }

}


function updateProductProperties(el){
	var qty = parseInt(el.val());
    var product_type = el.data("protype");
    var l = qty/2;
    var l2 = qty/1.9;
    var propertyObject = $("#order_roll");
    if(product_type == "Vinyl Flooring"){
      if(l<5){
       
        propertyObject.val('You will receive a roll of vinyl 2m wide and '+ l.toFixed(2) +'m long.');
      }
      if(l>=5 && l<50){
         

        propertyObject.val('');
      }
      if(l>=50){

        
        propertyObject.val('Please note a full roll of vinyl is 50 sq m, your order will be supplied in more than one piece.');
      }                

    }
    else if(product_type == "Okofloor"){

      if(l<5){


                      
		propertyObject.val('You will receive a roll of oko 2m wide and '+ l.toFixed(2) +'m long.');
        
      }
      if(l>=5 && l<50){


        
		propertyObject.val('');
        
      }
      
      if(l>=50){



                        
		propertyObject.val('Please note a full roll of oko is 50 sq m, your order will be supplied in more than one piece.');
      }                

    }
    else if(product_type == "Rubber Flooring"){

      if(l2<5)
      {

                        
		propertyObject.val('You will receive a roll of rubber 1.9m wide and '+ l2.toFixed(2) +'m long.');
      }

      if(l2 >= 5 && l2 < 19)
      {

        
		propertyObject.val('');
     
      }

      if(l2 >= 19)
      {


        
		propertyObject.val('Please note a full roll of rubber is 19 sq m, your order will be supplied in more than one piece.');
      }              

    }  
}  

  jQuery(window).on("load",function(){
  if($(".roomvo-button").css("visibility") === 'hidden'){
    $(".roomvo-button").hide();
  }
});
jQuery(document).ready(function($){
      $(document).on("click",".custom-rugs-smple-add-to-cart",function(){
          if($(".sample-custom-form-wrapper form").length > 0){
            $('.sample-custom-form-wrapper button[data-add-to-cart-trigger]').trigger("click");
          }
      });
  });